<template>
  <div class="e-questions">
    <template v-if="!selectedFlow">
      <div class="e-block-wrap">
        <div class="e-block">
          <div class="e-block__scroll" :style="{ minHeight: containerHeight }">
            <FlowSelector title="Choose Product Category"
                          :items="flowItems" />
          </div>
        </div>
        <div class="e-bottom-navbar">
          <button class="e-btn e-btn--prev" @click.prevent="previous">Previous</button>
        </div>
      </div>
    </template>
    <FlowContainer v-else />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FlowSelector from '@/components/FlowSelector.vue';
import FlowContainer from '@/components/FlowContainer.vue';
import { FLOW_TYPE } from '@/store';

export default {
  components: {
    FlowContainer,
    FlowSelector,
  },
  name: 'HelpMeChoose',
  data() {
    return {
      flowItems: [
        { title: 'Residential', value: FLOW_TYPE.RESIDENTIAL, class: 'residential' },
        { title: 'Commercial', value: FLOW_TYPE.COMMERCIAL, class: 'commercial' },
        { title: 'Specialty Products', value: FLOW_TYPE.SPECIAL, class: 'special' },
      ],
    };
  },
  mounted() {
    this.getMarkers();
    // @TODO need to rework
    const currentItems = [
      { name: 'Products', href: '/' },
      { name: 'Sizing & Selecting', href: '/help-me-choose' },
    ];
    currentItems.forEach((item) => {
      if (!this.initBreadcrumbs.find((step) => step.name === item.name)) {
        this.addBreadcrumbs(item);
      }
    });
  },
  computed: {
    ...mapState(['selectedFlow', 'steps', 'initBreadcrumbs', 'containerHeight']),
  },
  methods: {
    ...mapActions(['getMarkers', 'addBreadcrumbs', 'goToStep', 'setBreadcrumbs']),
    previous() {
      // @TODO need to rework
      const item = { name: 'Products', href: '/' };
      this.goToStep(null);
      if (this.$route.path !== item.href) {
        this.$router.push(item.href);
        const index = this.initBreadcrumbs.findIndex((step) => step.name === item.name);
        const steps = this.initBreadcrumbs.slice(0, index + 1);
        this.setBreadcrumbs(steps);
      }
    },
  },
};
</script>

<style lang="scss">

</style>
